// ✅ Set Cookie with Expiry (in days)
export const setCookie = (name, value, options = {}) => {
  const { path = '/', domain, secure, sameSite = 'Lax', days } = options;

  const expires = new Date();
  expires.setDate(expires.getDate() + days);

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)};`;
  cookieString += ` expires=${expires.toUTCString()};`;
  cookieString += ` path=${path};`;
  cookieString += ` SameSite=${sameSite};`;

  if (domain) cookieString += ` domain=${domain};`;
  if (secure) cookieString += ` secure;`;
  document.cookie = cookieString;
};

// ✅ Get Cookie by Name
export const getCookie = (name) => {
  const cookieArr = document.cookie.split('; ');
  for (let cookie of cookieArr) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === encodeURIComponent(name)) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

// ✅ Remove Cookie by Name
export const removeCookie = (name, options = {}) => {
  const { path = '/', domain } = options;
  let cookieString = `${encodeURIComponent(
    name,
  )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path};`;
  if (domain) cookieString += ` domain=${domain};`;
  document.cookie = cookieString;
};
